import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { IconError, SpacerVertical, SpacerHorizontal, Radio } from '@klarna/bubble-ui';
import { translator } from 'mage-i18n';
import { Alert, defaultContainerPropTypes, HorizontalWrapper, payloadUtils } from 'moet-core';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';

import { CAPS } from '@/constants';
import { BackButton, CallToActionButton, ContainerTemplate } from '@/components';
import { withCapabilityBeforeNext } from '@/flow/common';
import { preAssessmentDetails } from '@/selectors/merchant';

import { CY_MAIN_SELLING_COUNTRY_CONTAINER_IDS } from './constants';
import { getDefaultState } from './selectors';

const tPrefix = 'products-fe.containers.main_selling_country';

export class MainSellingCountry extends React.Component {
  constructor(props) {
    super(props);

    this.onToggle = this.onToggle.bind(this);
    this.getBody = this.getBody.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onNext = this.onNext.bind(this);

    const {
      defaultState: { countries = [], selected = null },
    } = props;

    this.state = {
      countries,
      selected,
      initialState: { countries, selected },
    };
  }

  getBody(state) {
    const { sellingCountries = { all: [] } } = this.props.preAssessmentDetails;

    return {
      sellingCountries: {
        all: sellingCountries.all,
        main: state.selected,
      },
    };
  }

  onToggle(selected) {
    this.setState({ selected, error: undefined });
  }

  onNext() {
    if (!this.state.selected) {
      this.setState({ error: this.props.t(`${tPrefix}.errors.invalid`) });
    } else {
      const payload = payloadUtils.getMerchantCapabilityPayload(
        this.props.mid,
        this.state,
        this.getBody,
      );
      this.props.onNext(payload);
    }
  }

  render() {
    const { error, hasBack, isDisabled, isLoading, onBack, t } = this.props;
    const { countries, selected, error: stateError } = this.state;

    return (
      <ContainerTemplate
        title={t(`${tPrefix}.title`)}
        subtitle={t(`${tPrefix}.subtitle`)}
        error={error}
      >
        <SpacerVertical small />
        {countries.map(c => (
          <Radio
            key={`selling-country-${c.key}`}
            omitFirstLine
            omitLastLine
            onChange={this.onToggle}
            options={[
              {
                description: c.label,
                value: c.key,
              },
            ]}
            value={selected}
          />
        ))}
        {stateError && <Alert type="error" content={stateError} icon={IconError} />}
        <SpacerVertical large />
        <HorizontalWrapper display="inline-flex" alignItems="center" justifyContent="flex-end">
          {hasBack && (
            <>
              <BackButton
                onClick={onBack}
                disabled={isDisabled}
                {...generateCyElemId(CY_MAIN_SELLING_COUNTRY_CONTAINER_IDS.BTN_BACK, window)}
              >
                {t(`${tPrefix}.buttons.back`)}
              </BackButton>
              <SpacerHorizontal medium />
            </>
          )}
          <CallToActionButton
            loading={isLoading}
            onClick={this.onNext}
            disabled={isDisabled}
            {...generateCyElemId(CY_MAIN_SELLING_COUNTRY_CONTAINER_IDS.BTN_SUBMIT, window)}
          >
            {t(`${tPrefix}.buttons.next`)}
          </CallToActionButton>
        </HorizontalWrapper>
      </ContainerTemplate>
    );
  }
}

MainSellingCountry.propTypes = {
  ...defaultContainerPropTypes,
  mid: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  defaultState: PropTypes.object,
};

export default compose(
  connect(state => ({
    defaultState: getDefaultState(state),
    preAssessmentDetails: preAssessmentDetails(state),
    t: translator(state),
  })),
  withCapabilityBeforeNext({
    cap: CAPS.V2_PRE_ASSESSMENT_PATCH,
  }),
)(MainSellingCountry);
